<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Expiration</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">

    <div class="form-group">
      <label for="modalAction">Action</label>
      <select class="custom-select"
              [(ngModel)]="modalAction"
              id="modalAction" name="modalAction">
        <option [ngValue]="ModalAction.ChangeExpiration">
          Change expiration date
        </option>
        <option [ngValue]="ModalAction.RemoveExpiration"
                *ngIf="redemptionCodeSet.expiration_date">
          Remove expiration date
        </option>
        <option [ngValue]="ModalAction.ExpireImmediately"
                *ngIf="redemptionCodeSet.status !== RedemptionCodeSetStatus.expired">
          Expire immediately
        </option>
      </select>
    </div>

    <div class="form-group indented-subsection"
         *ngIf="modalAction === ModalAction.ChangeExpiration">
      <label for="expirationDateInput">Expiration Date</label>
      <app-date-picker [id]="'expirationDateInput'"
                       [(content)]="expirationDate"></app-date-picker>
      <small class="form-text text-muted">
        The codes will expire at the end of the chosen date.
      </small>
    </div>

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSubmit"
            [disabled]="!submitAvailable()"
            [class.disabled]="!submitAvailable()"
            (click)="handleSubmit()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
